import { gql } from 'graphql-tag'
import {
  fragmentBlockMetrics,
  fragmentBlockContent,
  fragmentBlockSimpleQuote
} from '../../../../core/data-layer/blocks/fragments'
import {
  fragmentModuleInternalVideo,
  fragmentModuleMedia,
  fragmentModuleVideo
} from '../../../../core/data-layer/modules/fragments'
import fragmentBlockIndexHighlight from '../block-index-highlight/fragment-block-index-highlight'

export default gql`
  ${fragmentModuleMedia}
  ${fragmentBlockMetrics}
  ${fragmentBlockContent}
  ${fragmentBlockSimpleQuote}
  ${fragmentModuleVideo}
  ${fragmentModuleInternalVideo}
  ${fragmentBlockIndexHighlight}
  fragment BlockIndexContentGroupFragment on BlockIndexContentGroup {
    sys {
      id
    }
    contentBlocksCollection {
      items {
        contentType: __typename
        ... on ModuleMedia {
          ...ModuleMediaFragment
        }
        ... on BlockMetrics {
          ...BlockMetricsFragment
        }
        ... on BlockContent {
          ...BlockContentFragment
        }
        ... on BlockSimpleQuote {
          ...BlockSimpleQuoteFragment
        }
        ... on ModuleVideo {
          ...ModuleVideoFragment
        }
        ... on ModuleInternalVideo {
          contentType: __typename
          ...ModuleInternalVideoFragment
        }
        ... on BlockIndexHighlight {
          ...BlockIndexHighlightFragment
        }
      }
    }
  }
`
